/** Attribution agent commercial — cookie session 90 jours. */
const STORAGE_KEY = 'cepAgentCode';
const STORAGE_AT = 'cepAgentCodeAt';
const TTL_MS = 90 * 24 * 60 * 60 * 1000;

export function normalizeAgentCodeClient(raw) {
  const c = String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '');
  if (!c) return '';
  if (/^CEP-A-[A-Z0-9]{4,12}$/.test(c)) return c;
  if (/^[A-Z0-9]{4,12}$/.test(c)) return `CEP-A-${c}`;
  return c;
}

export function storeAgentCode(code) {
  const normalized = normalizeAgentCodeClient(code);
  if (!normalized) return '';
  try {
    sessionStorage.setItem(STORAGE_KEY, normalized);
    sessionStorage.setItem(STORAGE_AT, String(Date.now()));
    localStorage.setItem(STORAGE_KEY, normalized);
    localStorage.setItem(STORAGE_AT, String(Date.now()));
  } catch (_) {
    /* ignore */
  }
  return normalized;
}

export function getStoredAgentCode() {
  try {
    const fromSession = sessionStorage.getItem(STORAGE_KEY);
    const atSession = Number(sessionStorage.getItem(STORAGE_AT) || 0);
    if (fromSession && Date.now() - atSession < TTL_MS) {
      return normalizeAgentCodeClient(fromSession);
    }
    const fromLocal = localStorage.getItem(STORAGE_KEY);
    const atLocal = Number(localStorage.getItem(STORAGE_AT) || 0);
    if (fromLocal && Date.now() - atLocal < TTL_MS) {
      sessionStorage.setItem(STORAGE_KEY, fromLocal);
      sessionStorage.setItem(STORAGE_AT, String(atLocal || Date.now()));
      return normalizeAgentCodeClient(fromLocal);
    }
  } catch (_) {
    /* ignore */
  }
  return '';
}

/** Capture ?a= / ?agent= depuis l’URL courante. */
export function captureAgentCodeFromUrl(search = typeof window !== 'undefined' ? window.location.search : '') {
  try {
    const params = new URLSearchParams(search);
    const raw = params.get('a') || params.get('agent') || params.get('agentCode');
    if (raw) return storeAgentCode(raw);
  } catch (_) {
    /* ignore */
  }
  return getStoredAgentCode();
}
